import React from "react";

// Bio: simple, styled component to display an artist/professional biography
export default function Bio({ width = 420, fontSize = 13 }) {
  return (
    <div
      data-testid="bio-module"
      style={{
        width,
        background: "rgba(255,255,255,0.96)",
        border: "1px solid #e5e7eb",
        borderRadius: 8,
        padding: 12,
        boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
        fontFamily:
          "system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
        fontSize,
        color: "#111827",
        lineHeight: 1.45,
      }}
      aria-label="Bio module"
    >
      <div>
        Caleb Laven is an elite producer skilled at every aspect of the
        record-making process. Currently based in Los Angeles, he began his
        musical career in New York City, working with artists like{" "}
        <strong>Rostam Batmanglij</strong>, <strong>Bear in Heaven</strong> and{" "}
        <strong>Angel Haze</strong>. In 2014, Laven became a producer and
        creative mentor for the Philadelphia-based, indie rock band{" "}
        <strong>Joy Again</strong>, whose single{" "}
        <strong>“Looking Out for You”</strong>
        was certified platinum in 2022 after going viral on TikTok. In 2015,
        Laven started working with <strong>Frank Ocean</strong> as an engineer
        on the critically acclaimed, platinum album{" "}
        <strong>
          <em>Blonde</em>
        </strong>
        , its accompanying visual album{" "}
        <strong>
          <em>Endless</em>
        </strong>
        , and the releases that followed. Laven's recent projects include
        helping produce tracks on the 2024 releases{" "}
        <strong>
          <em>Dark Times</em>
        </strong>{" "}
        by <strong>Vince Staples</strong> and{" "}
        <strong>
          <em>Psykos</em>
        </strong>{" "}
        by <strong>Yung Lean and Bladee</strong>; as well as engineering, mixing
        and vocal producing across <strong>Travis Scott’s</strong>{" "}
        Grammy-nominated fourth studio album{" "}
        <strong>
          <em>UTOPIA (2023)</em>
        </strong>
        . Laven’s most recent work can be heard on <strong>Halsey’s</strong>{" "}
        latest album{" "}
        <strong>
          <em>The Great Impersonator</em>
        </strong>
        , for which he’s credited as vocal producer, and <strong>SZA’s</strong>{" "}
        <strong>
          <em>Lana</em>
        </strong>
        , which he helped finish. Laven was also tapped for the role of
        executive producer on <strong>godly the ruler’s</strong> first
        full-length album, released in August 2025 on the Pack. Records label.
      </div>

      <div style={{ height: 50 }} />

      <div style={{ fontWeight: 600, marginBottom: 40 }}>
        Notable Collaborations
      </div>
      <div>
        Other notable artists that Laven has collaborated with include:{" "}
        <strong>Charlie XCX</strong>,<strong>Childish Gambino</strong>,{" "}
        <strong>Nicki Minaj</strong>, <strong>Lianne La Havas</strong>,{" "}
        <strong>Bakar</strong>, <strong>Spice</strong>,{" "}
        <strong>Palmistry</strong>,<strong>Blood Orange</strong>,{" "}
        <strong>A$AP Mob</strong>, <strong>ARTHUR</strong>,{" "}
        <strong>Wallows</strong>, <strong>Merges</strong>,{" "}
        <strong>Sofia Valdés</strong>, <strong>Deb Never</strong>,
        <strong>Popcaan</strong>, <strong>Bakar</strong>, and{" "}
        <strong>Zsela</strong>.
      </div>
    </div>
  );
}
